
import {
  getFormattedDate,
  getFormattedValue,
  getCurrentDateISO8601
} from "@/shared.js";

export function section_Formatting() {

  const formatDate = (date) => {
    if (date) return getFormattedDate(date);
    else return "n/a";
  };

  const formatNumber = (xx) => {
    if (xx) return getFormattedValue(xx);
    else return "n/a";
  };

  const formatTD = (xx) => {
    if (xx) return xx.padStart(2, "0");
    else return "";
  };

  return {
    getFormattedDate,
    getFormattedValue,
    getCurrentDateISO8601,
    formatDate,
    formatNumber,
    formatTD
  };

};
